import React from 'react';
import {ChevronIcon} from '../ChevronIcon';
import {Image} from '@learningblocks/shared-components/lib/Image';
import Glossary from '@common/images/Glossary.svg';

import style from './style.module.scss';

export function IndexCollapsed() {
  return (
    <div className={style.indexCollapsed}>
      <Image src={Glossary} className={style.indexCollapsed_glossaryIcon} />
      <ChevronIcon className={style.indexCollapsed_arrowIcon} />
    </div>
  );
}
